"use client";

import { useState } from "react";

const Item = ({ title, children }: any) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border rounded shadow-sm">
            <button
                type="button"
                aria-label="Open item"
                title="Open item"
                className="flex items-center justify-between w-full p-4 focus:outline-none"
                onClick={() => setIsOpen(!isOpen)}
            >
                <h4 className="text-lg text-left font-medium">{title}</h4>
                <div className="flex items-center justify-center w-8 h-8 border rounded-full">
                    <svg
                        viewBox="0 0 24 24"
                        className={`w-3 text-gray-600 transition-transform duration-200 ${
                            isOpen ? "transform rotate-180" : ""
                        }`}
                    >
                        <polyline
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeMiterlimit="10"
                            points="2,7 12,17 22,7"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </button>
            {isOpen && (
                <div className="p-4 pt-0">
                    <p className="text-gray-700">{children}</p>
                </div>
            )}
        </div>
    );
};

export const Faq = () => {
    return (
        <div className="px-4 py-0 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-0">
            <div className="max-w-xl sm:mx-auto lg:max-w-2xl">
                <div className="flex flex-col mb-16 sm:text-center">
                    <div className="max-w-xl md:mx-auto sm:text-center lg:max-w-2xl">
                        <h2 className="max-w-lg mb-0 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
                            <span className="relative inline-block">
                                <svg
                                    viewBox="0 0 52 24"
                                    fill="currentColor"
                                    className="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-blue-gray-100 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
                                >
                                    <defs>
                                        <pattern
                                            id="ec5d8ef5-b853-4714-b94f-df28ec98eeb7"
                                            x="0"
                                            y="0"
                                            width=".135"
                                            height=".30"
                                        >
                                            <circle cx="1" cy="1" r=".7" />
                                        </pattern>
                                    </defs>
                                    <rect
                                        fill="url(#ec5d8ef5-b853-4714-b94f-df28ec98eeb7)"
                                        width="52"
                                        height="24"
                                    />
                                </svg>
                                <span className="relative">Întrebări</span>
                            </span>{" "}
                            frecvente
                        </h2>
                    </div>
                </div>
                <div className="space-y-4">
                    <Item title="Cat costa scoala de soferi in Bucuresti?">
                        <div className="card-body">
                            <p className="text-base">
                                Stim cat de important este pentru tine sa
                                cunosti pretul unei scoli de soferi in Bucuresti
                                inca de la bun inceput. De aceea iti punem la
                                dispozitie trei pachete, astfel:
                            </p>
                            <ol className="list-decimal pl-6">
                                <li className="text-base">
                                    Pachetul STANDARD costa doar 2499 de Lei si
                                    iti ofera flexibilitatea de a alege
                                    optiunile de care ai nevoie.
                                </li>
                                <li className="text-base">
                                    Pachetul CU DE TOATE costa doar 2699 de Lei
                                    si include tot ce ai nevoie pentru a
                                    finaliza scoala de soferi. In plus, ai
                                    GRATUIT masina rezervata in ziua examenului.
                                </li>
                                <li className="text-base">
                                    Pachetul Cutie AUTOMATA costa 2899 de Lei si are aceleasi
                                    beneficii ca cel CU DE TOATE, insa masina pe
                                    care vei face orele de condus si pe care vei
                                    sustine examenul practic nu are ambreiaj.
                                </li>
                            </ol>
                            <p className="text-base">
                                Aceste preturi scoala de soferi acopera
                                cheltuielile cu scolarizarea. Pentru a ti se
                                elibera permisul de conducere, inainte de
                                examenul teoretic, va trebui sa achiti (la
                                ghiseul Politiei) o taxa pentru permis.
                            </p>
                        </div>
                    </Item>
                    <Item title="Cat dureaza scoala auto? ¹">
                        <div className="card-body">
                            <p className="text-base">
                                Scoala de soferi se imparte in doua categorii:
                                partea teoretica si partea practica. Cea
                                teoretica presupune 24h de teorie, iar cea
                                practica presupune 15 sedinte de condus.
                            </p>
                            <p className="text-base">
                                Astfel, daca programul tau este flexibil si nu
                                ai anumite ore la care poti participa la
                                cursuri, ar trebui sa poti termina scoala de
                                soferi categoria B in aproximativ 5 saptamani de
                                la inscriere.
                            </p>
                        </div>
                    </Item>
                    <Item title="Unde pot face chestionare scoala de soferi?">
                        <div className="card-body">
                            <p className="text-base">
                                Pentru a trece cu succes prin toate cele 1000 de
                                intrebari scoala de soferi, iti recomandam in
                                primul rand sa parcurgi toata curicula oferita
                                de scoala rutiera categoria B.
                            </p>
                            <p className="text-base">
                                Dupa ce stapanesti teoria, site-ul oficial
                                DRPCIV iti pune la dispozitie un simulator al
                                examenului auto pe care poti face chestionare.
                                In plus, la sediul nostru gasesti intotdeauna un
                                set de teste pentru scoala de soferi, iar
                                profesorul de legislatie te poate ajuta atunci
                                cand ai intrebari.
                            </p>
                        </div>
                    </Item>
                    <Item title="Ce acte sunt necesare pentru scoala de soferi in Bucuresti?">
                        <div className="card-body">
                            <p className="text-base">
                                Dosarul de inscriere cu acte necesare scoala de
                                soferi Bucuresti trebuie sa cuprinda:
                            </p>
                            <ul className="list-disc ml-6">
                                <li>Copie Buletin</li>
                                <li>Cazier Judiciar</li>
                                <li>Set Analize Medicale</li>
                                <li>Aviz Psihologic cu mentiunea &ldquo;Apt&ldquo;</li>
                            </ul>
                            <p className="text-base">
                                In principiu, daca optezi pentru pachetul CU DE
                                TOATE, noi iti vom asigura GRATUIT vizitele
                                pentru obtinerea fisei medicale si a avizului
                                psihologic.
                            </p>
                        </div>
                    </Item>
                    <Item title="Cat este valabil examenul teoretic scoala de soferi?">
                        <div className="card-body">
                            <p className="text-base">
                                Examenul teoretic este prima proba care se
                                sustine dupa finalizarea cursurilor la scoala de
                                soferi. Promovarea acestuia este necesara pentru
                                a putea sustine examenul practic (traseul).
                            </p>
                            <p className="text-base">
                                Totusi, este nevoie sa promovezi proba teoretic
                                la o singura data, pe toata durata valabilitatii
                                dosarului. Asadar, daca din diferite motive ai
                                picat proba practica, nu va fi nevoie sa mai dai
                                inca odata sala, ci te vei putea reprograma
                                direct la traseu.
                            </p>
                            <p className="text-base">
                                In ce priveste valabilitatea examenului
                                teoretic, aceasta este strans legata de
                                valabilitatea dosarului. Dosarul in sine se
                                elibereaza de catre scoala de soferi Bucuresti
                                la finalizarea orelor si este valabil 1 an din
                                momentul respectiv.
                            </p>
                        </div>
                    </Item>
                    <Item title="Cat este valabil dosarul eliberat de scoala de soferi?">
                        <div className="card-body">
                            <p className="text-base">
                                Dosarul (respectiv fisa de scolarizare) este
                                documentul care atesta faptul ca ai finalizat
                                cursul pentru scoala de soferi categoria B.
                            </p>
                            <p className="text-base">
                                Acesta se elibereaza ce catre secretariatul
                                scolii de soferi dupa finalizarea celor 30 de
                                ore de condus si este valabil 1 an de zile.
                            </p>
                        </div>
                    </Item>
                    <Item title="De cate raspunsuri corecte am nevoie pentru a promova examenul auto?">
                        <div className="card-body">
                            <p className="text-base">
                                Examenul teoretic pentru scoala de soferi
                                categoria B consta din 26 de intrebari si
                                trebuie finalizat in cel mult 30 de minute.
                            </p>
                            <p className="text-base">
                                Pentru a fi declarat <strong>ADMIS</strong> la
                                aceasta proba, trebuie sa raspunzi corect la cel
                                putin 22 de intrebari.
                            </p>
                        </div>
                    </Item>
                    <Item title="Cate zile trebuie sa astept daca am picat sala?">
                        <div className="card-body">
                            <p className="text-base">
                                Daca nu ai reusit sa raspunzi corect la minim 22
                                de intrebari in cele 30 de minute alocate, vei
                                putea sustine din nou examenul in 15 zile
                                calendaristice.
                            </p>
                        </div>
                    </Item>
                    <Item title="Cate zile trebuie sa astept daca am picat traseul?">
                        <div className="card-body">
                            <p className="text-base">
                                Daca ai picat proba practica, veste buna este ca
                                totusi nu trebuie sa astepti pentru a te
                                reprograma. Tot ce trebuie sa faci este sa te
                                prezinti la Directia Permise din localitatea de
                                domiciliu si sa soliciti reprogramarea.
                            </p>
                            <p className="text-base text-red-500">
                                <strong>Atentie, insa!</strong> Politia te va
                                reprograma la prima data disponibila! Aceasta
                                poate fi in ziua urmatoare, dar se poate extinde
                                pe perioade mai lungi de timp, in functie de
                                disponibilitatea examinatorilor.
                            </p>
                        </div>
                    </Item>
                    <Item title="Pot face scoala de soferi in Bucuresti daca am domiciliul in alta localitate?">
                        <div className="card-body">
                            <p className="text-base">
                                Da, cursurile pentru scoala de soferi se pot
                                face oriunde in tara, indiferent de localitatea
                                de domiciliu. Cu toate acestea, sustinerea
                                examenelor va avea loc doar in localitatea de
                                resedinta.
                            </p>
                            <p className="text-base">
                                De exemplu, daca ai buletinul in Giurgiu si ai
                                facut scoala de soferi bucuresti, examenele le
                                vei da cu politia din Giurgiu.
                            </p>
                            <p className="text-base">
                                Daca insa ai facut scoala auto in Bucuresti si
                                vrei sa dai examenul aici,{" "}
                                <strong>
                                    poti totusi sa soliciti o viza de flotant.
                                </strong>
                            </p>
                        </div>
                    </Item>
                    <Item title="Pot face scoala de soferi in Romania daca am resedinta in alta tara?">
                        <div className="card-body">
                            <p className="text-base">
                                Inscrierea la scoala de soferi in vederea
                                obtinerii permisului de conducere in Romania se
                                poate face doar de catre persoane care au
                                resedinta in Romania.
                            </p>
                            <p className="text-base">
                                Acest lucru inseamna ca vei avea nevoie de o
                                carte de identitate romaneasca, sau de un permis
                                de sedere emis de catre autoritatile din
                                Romania.
                            </p>
                        </div>
                    </Item>
                    <Item title="Pot face scoala de soferi in limba engleza?">
                        <p className="text-base">Da, scoala de soferi Buzz desfasoara cursuri de scolarizare in limba engleza. Mai mult decat atat, chiar si examenele cu politia se pot sustine in limba engleza.</p>
                    </Item>
                    <Item title="La ce varsta ma pot inscrie la scoala de soferi categoria B?">
                        <p className="text-base">Da, scoala de soferi Buzz desfasoara cursuri de scolarizare in limba engleza. Mai mult decat atat, chiar si examenele cu politia se pot sustine in limba engleza.</p>
                    </Item>
                    <Item title="Cate clase trebuie sa am pentru a ma inscrie la scoala de soferi?">
                      <p className="text-base">In prezent, legea nu impune un anumit nivel de edicatie pentru a te inscrie la scoala de soferi categoria B. Asadar, cat timp poti citi si scrie pentru a invata legile de circulatie, te poti inscrie la cursurile de scolarizare auto categoria B.</p>
                    </Item>
                </div>
            </div>
        </div>
    );
};
